import { isEmpty } from 'lodash';

import { HTTP_METHOD_GET } from '../../constants/httpMethod';
import { REQUEST_ASSOCIATION, SUCCESS_ASSOCIATION, FAILURE_ASSOCIATION } from './constants';

import { CALL_API } from '../../middlewares/api';

export function fetchAssociationsIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/payment/association',
            method: HTTP_METHOD_GET,
            types: [REQUEST_ASSOCIATION, SUCCESS_ASSOCIATION, FAILURE_ASSOCIATION],
            shouldCallAPI: state => shouldFetchAssociations(state)
        }
    };
}

const shouldFetchAssociations = state => {
    const associations = state.association.associations;
    const fetching = state.association.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(associations)) {
        return true;
    } else {
        return false;
    }
};



// WEBPACK FOOTER //
// ./src/services/association/actions.js